import { Form, type FormItemProps } from "antd";
import type { TextAreaProps } from "antd/es/input";
import { Input } from "antd/lib";

interface Props extends FormItemProps {
  inputProps?: TextAreaProps;
}

export default function FormItemInputTextarea({ inputProps, ...rest }: Props) {
  return (
    <Form.Item {...rest} className={`${rest.className} mb-0!`}>
      <Input.TextArea
        classNames={{ textarea: "text-16-regular! resize-none!" }}
        {...inputProps}
      />
    </Form.Item>
  );
}
